import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './branchchampions.actions';
import * as fromState from './branchchampions.state';

const branchChampionsReducer = createReducer(
  fromState.getInitialBranchChampionsState(),
  on(fromActions.loadManySuccess, (state, { items }) => {
    return fromState.adapter.setAll(
      items!.map((item) => {
        return {
          ...item,
          id: item.requestId,
        } as fromState.BranchChampionsEntity;
      }),
      state,
    );
  }),
);

export function reducer(
  state: fromState.BranchChampionsState | undefined,
  action: Action,
) {
  return branchChampionsReducer(state, action);
}
